'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import TextInput from 'Components/Forms/Elements/TextInput';
import MaskedInput from 'react-text-mask';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MuiPhoneNumber from 'material-ui-phone-number';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import Recaptcha from 'Components/Recaptcha';
import CGUModal from 'Modals/CGUModal';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
const SiretMask = React.forwardRef(function SiretMask(props, ref) {
  const setRef = React.useCallback(maskedInputRef => {
    const value = maskedInputRef ? maskedInputRef.inputElement : null;
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref) {
      ref.current = value;
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, props, {
    ref: setRef,
    mask: [/[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
  }));
});
const TVAMask = React.forwardRef(function TVAMask(props, ref) {
  const setRef = React.useCallback(maskedInputRef => {
    const value = maskedInputRef ? maskedInputRef.inputElement : null;
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref) {
      ref.current = value;
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, props, {
    ref: setRef,
    mask: ['F', 'R', ' ', /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
  }));
});
export default class NewCompanyForm extends Component {
  state = {
    status_messages: {},
    created: false,
    'company[roles]': ['company'],
    cgu_modal: false,
    'company[cgu_accepted]': false
  };
  handleChange = handleChange.bind(this);
  handleFileChange = handleFileChange.bind(this);
  recaptchaRef = React.createRef();
  create = async e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true || state.redirecting) return;
    e?.persist();
    if (state['company[password]'] !== state['password_verification']) {
      return component.setState({
        error: 'Les mots de passe doivent être identique'
      });
    }
    if (state['company[login]'] !== state['login_verification']) {
      return component.setState({
        error: 'Les emails doivent être identique'
      });
    }
    if (!state.token) {
      return component.setState({
        error: 'Veuillez accepter le captcha pour continuer.'
      });
    }
    component.setState({
      loading: true
    });
    let company = new FormData();
    company.append('company[token]', state.token);
    company = getFormData({
      form_data: company,
      state: state,
      pattern: 'company['
    });
    qwest.post(action('RegisterNewCompany'), company).then(function (xhr, response) {
      app.emit({
        event: 'TC_Click',
        source: 'NewCompanyForm',
        data: {
          e: e,
          action: 'creation_compte_entreprise'
        }
      });
      component.setState({
        loading: false,
        created: true,
        info: response.info,
        error: undefined,
        warning: undefined,
        redirecting: true,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo('/connexion-entreprise');
      }, 5000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'company[phone_number]'
    });
  };
  openCGUModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      cgu_modal_trigger: e.target,
      cgu_modal: true
    });
  };
  closeCGUModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      cgu_modal_trigger: undefined,
      cgu_modal: false
    });
  };
  handleCaptcha = (token = '') => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      token: token
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: action('RegisterNewCompany')
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 6
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[name]'],
      name: "company[name]",
      type: "text",
      label: "Raison sociale *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[siret]'],
      name: "company[siret]",
      inputComponent: SiretMask,
      type: "text",
      label: "SIRET *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[num_tva]'],
      name: "company[num_tva]",
      inputComponent: TVAMask,
      type: "text",
      label: "Num\xE9ro TVA intracommunautaire *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      value: state['company[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone *",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[contact][lastname]'],
      name: "company[contact][lastname]",
      type: "text",
      label: "Nom du contact principal *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[contact][firstname]'],
      name: "company[contact][firstname]",
      type: "text",
      label: "Pr\xE9nom du contact principal *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][line_1]'],
      name: "company[address][line_1]",
      type: "text",
      label: "Adresse du si\xE8ge social *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][line_2]'],
      name: "company[address][line_2]",
      type: "text",
      label: "Compl\xE9ment d'adresse du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][postal_code]'],
      name: "company[address][postal_code]",
      type: "text",
      label: "Code postal du si\xE8ge social *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][city]'],
      name: "company[address][city]",
      type: "text",
      label: "Ville du si\xE8ge social *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][country]'],
      name: "company[address][country]",
      type: "text",
      label: "Pays du si\xE8ge social *",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[login]'],
      name: "company[login]",
      type: "text",
      label: "E-mail de connexion *",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['login_verification'],
      name: "login_verification",
      type: "text",
      label: "Confirmation e-mail de connexion *",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[password]'],
      name: "company[password]",
      type: "password",
      label: "Mot de passe *",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password_verification'],
      name: "password_verification",
      type: "password",
      label: "Confirmation mot de passe *",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onChange: component.handleChange,
      className: bemit('c-form-element', ['reservation']) + ' custom-checkbox',
      value: state['company[cgu_accepted]'],
      name: "company[cgu_accepted]",
      "full-width": false,
      status: state.status_messages,
      label: "J'ai lu et accepte les "
    }, /*#__PURE__*/React.createElement(Button, {
      className: 'u-margin-left-5 ' + bemit('c-link', ['cgu']),
      onClick: component.openCGUModal
    }, "Conditions de Vente et d'Annulation\xA0*"))), /*#__PURE__*/React.createElement(Recaptcha, {
      onTokenGeneration: component.handleCaptcha,
      name: "company_form"
    })), status), state.created !== true ? /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary'].concat(state.redirecting ? ['disabled'] : [])),
      onClick: component.create,
      disabled: state.redirecting
    }, "Cr\xE9er ce compte entreprise", loader)) : undefined, /*#__PURE__*/React.createElement(CGUModal, {
      onClose: component.closeCGUModal,
      open: state.cgu_modal,
      trigger_src: state.cgu_modal_trigger
    }));
    return output;
  }
}
